import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatLabel', standalone: true })
export class FormatLabelPipe implements PipeTransform {
  transform({ name, value }: { name: string; value: string }): string {
    return `${value}${value && name ? ' - ' + name : ''}`;
  }
}
